/* eslint-disable */
export default {
  _Background: 'Background',
  _NewspaperStack: 'NewspaperStack',
  _sign: 'sign',
  _GatorArmRight: 'GatorArmRight',
  _LevelLabel: 'LevelLabel',
  _pauseBtn: 'pauseBtn',
  _ClosedEyes1: 'ClosedEyes1',
  _ClosedEyes2: 'ClosedEyes2',
  _ProgressBar: 'ProgressBar',
  _ClosedEyes3: 'ClosedEyes3',
  _ClosedEyes4: 'ClosedEyes4',
  _Eyes2: 'Eyes2',
  _Super: 'Super',
  _Eyes1: 'Eyes1',
  _EndingNewspaper: 'EndingNewspaper',
  _BackgroundLargerGutter: 'BackgroundLargerGutter',
  _Great: 'Great',
  _LowerJaw1: 'LowerJaw1',
  _GatorTail: 'GatorTail',
  _Paused: 'Paused',
  _ResultsPage: 'ResultsPage',
  _ArrowLEFT: 'ArrowLEFT',
  _ArrowRIGHT: 'ArrowRIGHT',
  _PlayButton: 'PlayButton',
  _VolumeButton: 'VolumeButton',
  _MuteButton: 'MuteButton',
  _hammer: 'hammer',
  _eyeClosed1: 'eyeClosed1',
  _eyeClosed2: 'eyeClosed2',
  _eyeClosed3: 'eyeClosed3',
  _eyeClosed4: 'eyeClosed4',
  _Subtitle: 'Subtitle',
  _Score: 'Score',
  _sewerMask: 'sewerMask',
  _HeadTop1: 'HeadTop1',
  _Head1: 'Head1',
  _Head2: 'Head2',
  _SewerLid: 'SewerLid',
  _BackgroundTitle: 'BackgroundTitle',
  _popupBG: 'popupBG',
  _UIBar: 'UIBar',
  _TimesUp: 'TimesUp',
  _popupMask: 'popupMask',
  _CorrectAnswer: 'CorrectAnswer',
  _Torso2: 'Torso2',
  _Torso3: 'Torso3',
  _IncorrectAnswer: 'IncorrectAnswer',
  _Head3: 'Head3',
  _Torso1: 'Torso1',
  _cloud: 'cloud',
  _Torso4: 'Torso4',
  _Head4: 'Head4',
  _LowerJaw2: 'LowerJaw2',
  _LowerJaw3: 'LowerJaw3',
  _LowerJaw4: 'LowerJaw4',
  _Got_It: 'Got It',
  _SewerHole: 'SewerHole',
  _NextBTN: 'NextBTN',
  _StartOverButton: 'StartOverButton',
  _LevelComplete: 'LevelComplete',
  _HomeBTN: 'HomeBTN',
  _ReplayBTN: 'ReplayBTN',
  _ResumeButton: 'ResumeButton',
  _NextButton: 'NextButton',
}